module.exports = __webpack_public_path__ + "static/media/dot-bg.f3005bc5.svg";